import { Bootstrap } from '@g.frame/core';
import LevelsManager from './levels/LevelsManager';
import { Loader } from '@g.frame/common.loaders';
import Preloader from './modules/preloader/Preloader';
// extends Bootstrap
// export class Main extends AbstractModule {
export class Main extends Bootstrap {
    constructor() {
        super();
    }
    onInit(modulesProcessor) {
        super.onInit(modulesProcessor);
        this.modulesProcessor = modulesProcessor;
        this.preloader = new Preloader(modulesProcessor);
        this.preloader.init();
        this.preloader.show();
        this.addObject(this.levelsManager = new LevelsManager(modulesProcessor, this.preloader));
        modulesProcessor.agents.get(Loader).load().then(() => {
            this.levelsManager.init();
            this.preloader.hide();
        });
        modulesProcessor.viewer.renderer.setPixelRatio(devicePixelRatio);
    }
}
